import React from 'react';
import Circle from './components/circle'
import './App.css';

function App() {
  return (
    <div className="App">
      <Circle />
    </div>
  );
}

export default App;
